import olapan1 from '../../Media/Produk/O8.webp'
import olapan2 from '../../Media/Produk/O8.webp'



const O8images =[
    olapan1,olapan2
]

export default O8images;